import AuthModal from '@/components/auth/AuthModal'
import BottomNav from '@/components/layout/BottomNav'
import Header from '@/components/layout/Header'
import { useAuthModal } from '@/contexts/AuthModalContext'
import { Toaster } from 'react-hot-toast'
import { Outlet } from 'react-router-dom'

function Layout() {
  const { isOpen, openAuth, closeAuth } = useAuthModal()

  return (
    <div className="min-h-screen overflow-x-hidden bg-black text-white">
      <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
        <div
          className="absolute inset-0 opacity-70"
          style={{
            backgroundImage:
              'radial-gradient(ellipse 70% 48% at 50% -8%, rgba(255,26,26,0.28), transparent), radial-gradient(circle at 8% 18%, rgba(59,76,202,0.34), transparent 36%), radial-gradient(circle at 92% 12%, rgba(255,222,0,0.22), transparent 32%), radial-gradient(circle at 80% 88%, rgba(59,76,202,0.16), transparent 28%)',
          }}
        />
        <div className="sticker-dots absolute inset-0 opacity-40" />
        <div className="absolute -left-10 top-28 h-24 w-24 rounded-full border-[6px] border-[#FFDE00]/40" />
        <div className="absolute right-8 top-40 h-10 w-10 rotate-12 rounded-lg bg-[#FF1A1A]/70" />
        <div className="absolute bottom-16 left-1/4 h-6 w-6 rounded-full bg-[#3B4CCA]" />
      </div>
      <div className="relative z-10 pb-28 sm:pb-24">
        <Header onAuthOpen={openAuth} />
        <Outlet />
      </div>
      <BottomNav onAuthOpen={openAuth} />
      <AuthModal open={isOpen} onClose={closeAuth} />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: '#111111',
            color: '#fff',
            border: '2px solid rgba(255,222,0,0.35)',
            borderRadius: '18px',
            fontWeight: 700,
          },
        }}
      />
    </div>
  )
}

export default Layout
